import { Image } from '@cue/atoms';
import { LocalStorageUtil } from '@cue/utility';
import { useEffect, useMemo, useState } from 'react';
import { CMS_Content_Module_StoryData, CMS_Content_Module_Story_Element } from './types';
import { Modal, Slider, useModal } from '@cue/organisms';

import { Controller } from 'swiper/modules';
import { useResponsive } from '@cue/hooks';
export type StoryProps = CMS_Content_Module_StoryData;

export const Story = (props: StoryProps) => {
  const { stories, id, mark_viewed } = props;

  const STORAGE_SELECTOR = `seenSlider_${id}`;
  const localSeenVideos: string | null = LocalStorageUtil.get(STORAGE_SELECTOR);
  const [sortetStories, setSortetStories] = useState(stories);
  const [activeIndex, setActiveIndex] = useState(-1);
  const [seenStories, setSeenStories] = useState<string[]>(
    localSeenVideos ? JSON.parse(localSeenVideos) : [],
  );
  const [slideModal] = useModal();
  const { isLarge, isMobile } = useResponsive();

  const [controlledSwiper, setControlledSwiper] = useState(null);

  useEffect(() => {
    // get First story ot seen
    const seen = stories.filter((s) => localSeenVideos?.includes(s.id));
    const notSeen = stories.filter((s) => !localSeenVideos?.includes(s.id));
    //const sortedSecondArray = stories.slice().sort(customSort);
    // console.log('localSeenVideos', sortedSecondArray);
    setSortetStories([...seen, ...notSeen]);
    setActiveIndex(seen.length + (!isLarge ? 3 : 5));
  }, []);

  const addSeenStory = (id: string) => {
    if (!mark_viewed) return;
    const newSeenStories = !seenStories.includes(id) ? [...seenStories, id] : seenStories;
    LocalStorageUtil.set(STORAGE_SELECTOR, JSON.stringify(newSeenStories));

    setSeenStories(newSeenStories);
  };

  const thumbSlider = useMemo(
    () =>
      sortetStories.map((story, index) => (
        <StoryElement
          image={story}
          seen={!mark_viewed && seenStories.includes(story.id)}
          key={story.id}
          onClick={() => {
            setActiveIndex(index);
            addSeenStory(story.id);
            slideModal.current?.open();
          }}
        />
      )),
    [sortetStories, seenStories],
  );

  const modalStories = useMemo(
    () => sortetStories.map((story) => <StoryElement image={story} key={story.id} modal />),
    [sortetStories],
  );

  return (
    <>
      {activeIndex >= -1 && (
        <Slider
          className="cue-grid-slider cue-story-slider"
          onSwiper={(swiper) => {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            if (isMobile) setControlledSwiper(swiper);
          }}
          initialSlide={activeIndex}
          spaceBetween={10}
          slidesPerView={isLarge ? 6 : 3}
          slidesPerGroup={3}
          loop
          loopAdditionalSlides={6}
          breakpoints={{
            769: {
              spaceBetween: 28,
              slidesPerView: 6,
              slidesPerGroup: 6,
            },
          }}
          pagination={{ enabled: true, clickable: true }}
          navigation={false}>
          {thumbSlider}
        </Slider>
      )}
      <Modal
        ref={slideModal}
        className="cue-story-modal"
        overrideCSS={{
          '.cue-modal-backdrop .cue-modal-container': { background: 'none' },
          '.cue-modal-content': { width: '90vw', maxWidth: 1280, background: 'transparent' },
          '.cue-modal-close-button-wrapper': { right: '0px !important', top: '0px !important' },
        }}>
        <Slider
          modules={isMobile ? [Controller] : []}
          controller={{ control: controlledSwiper }}
          initialSlide={activeIndex}
          className="cue-grid-slider cue-story-slider cue-story-slider-modal"
          pagination={{ enabled: false, clickable: true }}
          spaceBetween={10}
          loop
          onSlideChange={(e) => {
            addSeenStory(sortetStories[e.activeIndex]?.id);

            //setSeenStories([...seenStories, stories[e.activeIndex]?.id]);
          }}>
          {modalStories}
        </Slider>
      </Modal>
    </>
  );
};

export const StoryElement = (
  props: CMS_Content_Module_Story_Element & {
    seen?: boolean;
    onClick?: () => void;
    modal?: boolean;
  },
) => {
  const { image, onClick, seen, modal } = props;
  return (
    <div
      className={`cue-story-slider-element ${seen ? 'cue-story-slider-element-seen' : ''}`}
      onClick={() => onClick && onClick()}>
      {modal ? (
        <div
          className="cue-story-slider-element-modal"
          style={{ backgroundImage: `url(${image.src})` }}></div>
      ) : (
        <div className="cue-story-slider-element-image">
          <Image src={image.src} srcSet={image.srcSet} />
        </div>
      )}
    </div>
  );
};
/* ${seen ? 'cue-story-slider-element-seen' : ''}` */
